module.exports = __webpack_public_path__ + "153eb36e2e7b4b73eb6892c7f81ae721.pdf";